import { render } from "./MenuView.vue?vue&type=template&id=0873d080&scoped=true"
import script from "./MenuView.vue?vue&type=script&lang=js"
export * from "./MenuView.vue?vue&type=script&lang=js"

import "./MenuView.vue?vue&type=style&index=0&id=0873d080&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0873d080"]])

export default __exports__